import { useCallback, useState } from 'react'
import moment from 'moment'
import { api } from 'lib/axios'

const logActivityRequest = async payload => {
  const response = await api.post(
    '/Api/V8/custom/customer/log-activity',
    payload
  )
  return response
}

export const useLogActivity = () => {
  const [isLogActivityLoading, setIsLogActivityLoading] = useState(false)

  const logApiActivity = useCallback(
    async ({
      contactId,
      agentId,
      apiEndpoint,
      actionType,
      fieldName,
      oldValue,
      newValue,
      requestPayload,
      apiCall
    }) => {
      const startMoment = moment()
      let response

      try {
        if (typeof apiCall === 'function') {
          response = await apiCall()
        }
        return response
      } catch (error) {
        throw error
      } finally {
        const endMoment = moment()

        const resolvedContactId =
          typeof contactId === 'function' ? contactId(response) : contactId

        const payload = {
          contact_id: resolvedContactId,
          agent_id: agentId,
          api_endpoint: apiEndpoint,
          action_type: actionType,
          start_time: startMoment.format('YYYY-MM-DD HH:mm:ss'),
          end_time: endMoment.format('YYYY-MM-DD HH:mm:ss'),
          request_payload: requestPayload
        }
        if (fieldName != null) {
          payload.field_name = fieldName
        }
        if (oldValue != null) {
          payload.old_value = oldValue
        }
        if (newValue != null) {
          payload.new_value = newValue
        }

        setIsLogActivityLoading(true)
        try {
          await logActivityRequest(payload)
        } catch (logError) {
          console.error('Failed to log API activity', logError)
        } finally {
          setIsLogActivityLoading(false)
        }
      }
    },
    []
  )

  const logBatchApiActivity = useCallback(
    async ({
      contactId,
      agentId,
      apiEndpoint,
      actionType,
      fieldName,
      oldValue,
      newValue,
      requestPayload,
      startTime,
      endTime
    }) => {
      setIsLogActivityLoading(true)
      try {
        const resolvedContactId =
          typeof contactId === 'function' ? contactId() : contactId

        const payload = {
          contact_id: resolvedContactId,
          agent_id: agentId,
          api_endpoint: apiEndpoint,
          action_type: actionType,
          start_time: startTime,
          end_time: endTime,
          request_payload: requestPayload
        }
        if (fieldName != null) {
          payload.field_name = fieldName
        }
        if (oldValue != null) {
          payload.old_value = oldValue
        }
        if (newValue != null) {
          payload.new_value = newValue
        }

        await logActivityRequest(payload)
      } catch (logError) {
        console.error('Failed to log batch API activity', logError)
      } finally {
        setIsLogActivityLoading(false)
      }
    },
    []
  )

  return {
    isLogActivityLoading,
    logApiActivity,
    logBatchApiActivity
  }
}
